import { Knowledge } from '@front-activerse/modules';
import { Route } from '../Routing/types';
import { ARTICLES_PER_PAGE, TRUNCATE_LIMIT, CATEGORIES, CATEGORY_AS_NUMBER } from './consts';
import descendantRoutes from './descendantRoutes';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = CATEGORIES.map((category) => ({
  path: `/knowledge/${category}/*`,
  element: (
    <Knowledge
      descendantRoutes={descendantRoutes}
      articlesPerPage={ARTICLES_PER_PAGE}
      truncateLimit={TRUNCATE_LIMIT}
      categories={CATEGORIES}
      categoryAsNumber={CATEGORY_AS_NUMBER}
    />
  ),
  private: false,
  title: dummy_t('feed.navbarTitle'),
  mobileAppTabIdentifier: 'profile',
}));

//for backward compatibility with native app
routes.push({
  path: `/knowledge/*`,
  element: (
    <Knowledge
      descendantRoutes={descendantRoutes}
      articlesPerPage={ARTICLES_PER_PAGE}
      truncateLimit={TRUNCATE_LIMIT}
      categories={CATEGORIES}
      categoryAsNumber={CATEGORY_AS_NUMBER}
    />
  ),
  private: false,
  title: dummy_t('feed.navbarTitle'),
  mobileAppTabIdentifier: 'profile',
});

export default routes;
